import { Component, OnInit } from '@angular/core';
import { NavParams, Platform } from '@ionic/angular';
import { delay } from 'rxjs/operators';
import { Navigator } from 'src/app/services/routing/navigator';
import { BalanceModel } from 'src/app/models/balance-model';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-account-balance',
  templateUrl: './account-balance.component.html',
  styleUrls: ['./account-balance.component.scss'],
})
export class AccountBalanceComponent implements OnInit {
  public accountBalances: BalanceModel;
  reservedCashOptions;
  reservedCashList:[];
  revampedReservedCashList:[];
  public hideBackButtonInNav = false;

  constructor(
    public userSession: UserSessionService,
    public balanceService: AccountBalanceService,
    public platform: Platform,
    public config: ConfigService,
    private appLinks: AppLinksService,
    private utils: UtilsService,
    private navigator: Navigator,
    private navParams: NavParams
  ) { }

  ngOnInit() {
    if(this.navParams?.data?.hideBack) {
      this.hideBackButtonInNav = true;
    } else {
      this.hideBackButtonInNav = false;
    }
    this.reservedCashOptions = JSON.parse(this.config.getConfig().FEATURE_BALANCE_RESERVED_BALANCE_OPTIONS 
    || '[{"tag": "BIG_WIN","label": "Big Win"},{"tag": "PAYOUT","label": "Pending Payout"},{"tag": "SPORTS_BET","label": "Sports Bet"}]');

    this.balanceService.updateBalance(); 
    this.balanceService.getBalance().pipe(delay(300)).subscribe((response: BalanceModel) => {
      this.accountBalances = response;
    });

    this.balanceService.getAccountBalanceLocks().subscribe((res:any) => {
      if(!!res.result){
        this.reservedCashList = res.payload;
      }
    });
  }

  mapReasonForLock(tag) {
    let l = this.reservedCashOptions.find(o => {
      return o.tag === tag;
    });
    if(l){
      return l.label;
    }
  }
  
  onBonusDetails() {
    this.navigator.navigateTo('ActiveBonusesComponent', { multipleModals: true });
  }

}
